// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Core card styles */
.user-card {
    transition: all 0.3s ease;
    height: 100%;
}

.user-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.user-image-container {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
}

.image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    background-color: #f8f9fa;
}

.user-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
}

.user-card .badge {
    font-size: 0.7rem;
    padding: 0.3em 0.6em;
}

.user-card .text-muted {
    font-size: 12px;
}

.user-card .card-body {
    padding: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.user-card h5.fs-16 {
    font-size: 14px !important;
    margin-bottom: 2px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-card .text-muted.mb-0 {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-card .hstack {
    margin-top: 8px;
}

.user-card .pt-3 {
    margin-top: auto;
    font-size: 12px;
}

.user-card .fs-12 {
    color: #74788d;
    margin-bottom: 4px !important;
}

.user-card .fs-14 {
    font-size: 13px !important;
    min-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-card .row .col-6 {
    margin-bottom: 12px;
}

.user-card .d-flex.align-items-start {
    margin-bottom: 12px;
}

.pagination-info {
    color: #74788d;
    font-size: 13px;
}

.clickable {
    cursor: pointer;
    transition: all 0.2s;
}

.clickable:hover {
    color: #556ee6;
}

.user-stats .btn-link {
    color: #556ee6;
    font-size: 14px;
}

.user-stats .btn-link:hover {
    color: #485ec4;
}

.profile-details h4 {
    margin-bottom: 0.5rem;
}

.profile-details .basic-info,
.profile-details .search-preferences,
.profile-details .attributes {
    background-color: #f8f9fa;
    padding: 1.5rem;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;
}

.profile-details h5 {
    color: #495057;
    font-size: 1.1rem;
    margin-bottom: 1rem;
}

.profile-details h6 {
    color: #6c757d;
    font-size: 1rem;
}

.profile-details p {
    margin-bottom: 0.5rem;
}

.profile-details strong {
    color: #495057;
}

.attribute-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
}

.attribute-group:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.profile-carousel {
    background: #f8f9fa;
    border-radius: 8px;
    overflow: hidden;
    height: 325px;
    margin-bottom: 1rem;
    position: relative;
}

.profile-carousel .carousel-inner,
.profile-carousel .carousel-item {
    height: 100%;
    width: 100%;
    background: #f8f9fa;
}

/* Update image styles to maintain aspect ratio */
.profile-carousel img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Update video styles to match */
.profile-carousel video {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #000;
}

.profile-carousel .ratio {
    width: 100%;
    height: 100%;
}

/* Keep the carousel item relative for absolute positioning of images/videos */
.profile-carousel .carousel-item {
    position: relative;
}

.profile-carousel .carousel-control-prev,
.profile-carousel .carousel-control-next {
    background: rgba(0,0,0,0.2);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 10px;
    z-index: 3;
}

.profile-carousel .carousel-indicators {
    margin-bottom: 0.5rem;
    z-index: 3;
}

.attribute-item {
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 0.5rem;
    height: 100%;
}

.attribute-item h6 {
    color: #495057;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.attribute-item p {
    color: #6c757d;
    font-size: 0.875rem;
}

.nav-tabs .nav-link {
    color: #495057;
    font-weight: 500;
    padding: 0.75rem 1rem;
}

.nav-tabs .nav-link.active {
    color: #556ee6;
    border-bottom: 2px solid #556ee6;
}

.badge {
    padding: 0.5em 0.75em;
    font-weight: 500;
}

.preference-group {
    background-color: #f8f9fa;
    padding: 1.25rem;
    border-radius: 0.5rem;
}

.preference-group h6 {
    color: #495057;
    font-size: 0.95rem;
    font-weight: 600;
}

.preference-group p {
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
}

.preference-group p:last-child {
    margin-bottom: 0;
}

/* Profile Tab Styling */
.user-header {
    text-align: center;
    padding: 1.5rem;
    background: linear-gradient(to right, #556ee6, #34c38f);
    border-radius: 1rem;
    color: white;
}

.user-header h3 {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.user-meta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.username {
    font-size: 1.1rem;
    opacity: 0.9;
}

.profile-completion-bar {
    max-width: 300px;
    margin: 0 auto;
}

.progress-bar {
    background: #34c38f;
}

/* Stats Cards */
.stat-card {
    background: white;
    padding: 1.5rem;
    border-radius: 1rem;
    text-align: center;
    box-shadow: 0 0 15px rgba(0,0,0,0.05);
    transition: transform 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.stat-card i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.stat-card h4 {
    margin-bottom: 0.25rem;
    font-weight: 600;
}

.stat-card span {
    color: #74788d;
    font-size: 0.9rem;
}

/* Info Cards */
.info-card {
    background: white;
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 0 15px rgba(0,0,0,0.05);
}

.info-header {
    background: #f8f9fa;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-bottom: 1px solid #e9ecef;
}

.info-header i {
    font-size: 1.5rem;
    color: #556ee6;
}

.info-header h5 {
    margin: 0;
    font-weight: 600;
}

.info-content {
    padding: 1.5rem;
}

.info-item {
    margin-bottom: 1.25rem;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-item label {
    display: block;
    color: #74788d;
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
}

.info-item p {
    margin: 0;
    font-weight: 500;
}

.about-text {
    font-size: 1rem;
    line-height: 1.6;
    color: #495057;
}

.status-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.status-item i {
    font-size: 1.25rem;
}

.status-item span {
    font-size: 0.95rem;
    color: #495057;
}

.profile-carousel .carousel-item.active {
    display: flex;
    justify-content: center;
    align-items: center;
}

.video-wrapper {
    position: relative;
    cursor: pointer;
    height: 100%;
    width: 100%;
}

.video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.2);
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 2;
}

.video-wrapper:hover .video-overlay {
    opacity: 1;
}

.video-overlay i {
    font-size: 48px;
    color: white;
    pointer-events: none;
}

/* Add these styles for tabs */
.nav-link {
    cursor: pointer;
}

.nav-tabs .nav-link {
    cursor: pointer;
    transition: all 0.3s ease;
}

.nav-tabs .nav-link:hover {
    background-color: #f8f9fa;
    border-color: transparent;
}

.nav-tabs .nav-link.active {
    border-bottom: 2px solid #556ee6;
    background-color: transparent;
}

/* Add responsive styles */
@media (max-width: 1200px) {
    .profile-carousel {
        height: 400px;
    }
}

@media (max-width: 992px) {
    .profile-carousel {
        height: 350px;
    }
}

@media (max-width: 768px) {
    .profile-carousel {
        height: 300px;
    }

    .info-card {
        margin-bottom: 1rem;
    }

    .info-header {
        padding: 0.75rem 1rem; /* Smaller padding on mobile */
    }

    .info-content {
        padding: 1rem; /* Smaller padding on mobile */
    }

    .status-item {
        margin-bottom: 0.75rem;
    }

    /* Make tabs scrollable horizontally on mobile */
    .nav-tabs {
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        white-space: nowrap;
        margin-bottom: 1rem;
    }

    .nav-tabs::-webkit-scrollbar {
        display: none; /* Hide scrollbar on mobile */
    }

    .nav-tabs .nav-link {
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
    }

    /* Adjust table display on mobile */
    .table-responsive {
        margin-bottom: 1rem;
    }

    /* Adjust pagination on mobile */
    .pagination {
        justify-content: center;
        flex-wrap: wrap;
    }

    .pagination-item {
        margin: 0.25rem;
    }

    /* Improve attribute display on mobile */
    .attribute-item {
        margin-bottom: 1rem;
    }

    .attribute-item h6 {
        font-size: 0.9rem;
    }

    .attribute-item p {
        font-size: 0.85rem;
    }
}

@media (max-width: 576px) {
    .profile-carousel {
        height: 250px;
    }

    .info-header h5 {
        font-size: 1rem;
    }

    .status-item {
        font-size: 0.85rem;
    }

    .about-text {
        font-size: 0.9rem;
    }

    /* Update button styles for mobile */
    .action-buttons {
        flex-direction: row !important;
        flex-wrap: wrap;
        gap: 0.5rem !important;
        justify-content: flex-end;
    }

    .action-buttons .btn {
        width: auto !important;
        padding: 0.5rem !important;
    }

    .action-buttons .btn span {
        display: none; /* Hide button text */
    }

    .action-buttons .btn i {
        margin: 0 !important; /* Remove icon margin */
        font-size: 1.1rem;
    }

    /* Make filter button square */
    .action-buttons .dropdown button {
        width: auto !important;
        padding: 0.5rem !important;
    }

    .action-buttons .dropdown button span {
        display: none;
    }

    /* Adjust search bar width */
    .search-box {
        width: 150px !important;
        margin-left: auto;
    }

    /* Adjust header layout */
    .card-header .row {
        display: flex;
        align-items: center;
    }

    .card-header .col-sm-4 {
        margin-bottom: 0 !important;
        padding: 0 0.5rem;
    }

    /* Title adjustments */
    .card-title {
        text-align: left;
        margin-bottom: 0 !important;
        font-size: 1rem;
    }
}

/* Attributes Tab Styling */
.attributes-wrapper {
    padding: 1rem;
}

.attribute-section {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 15px rgba(0,0,0,0.05);
}

.attribute-group-header {
    background: #f8f9fa;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-bottom: 1px solid #e9ecef;
}

.attribute-group-header i {
    font-size: 1.25rem;
    color: #556ee6;
}

.attribute-group-header h5 {
    margin: 0;
    font-weight: 600;
    color: #495057;
}

.attribute-group-content {
    padding: 1.5rem;
}

.attribute-card {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    height: 100%;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
}

.attribute-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    border-color: #556ee6;
}

.attribute-title {
    color: #495057;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.attribute-value {
    color: #6c757d;
    font-size: 0.875rem;
    margin: 0;
    line-height: 1.5;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .attribute-group-content {
        padding: 1rem;
    }

    .attribute-card {
        padding: 0.875rem;
    }

    .attribute-title {
        font-size: 0.85rem;
    }

    .attribute-value {
        font-size: 0.8rem;
    }
}

/* Search Preferences Styling */
.preferences-wrapper {
    padding: 1rem;
}

.preference-section {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 15px rgba(0,0,0,0.05);
}

.preference-group-header {
    background: #f8f9fa;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-bottom: 1px solid #e9ecef;
}

.preference-group-header i {
    font-size: 1.25rem;
    color: #556ee6;
}

.preference-group-header h5 {
    margin: 0;
    font-weight: 600;
    color: #495057;
}

.preference-group-content {
    padding: 1.5rem;
}

.preference-card {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 8px;
    height: 100%;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
    text-align: center;
}

.preference-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    border-color: #556ee6;
}

.preference-icon {
    margin-bottom: 1rem;
}

.preference-icon i {
    font-size: 2rem;
    color: #556ee6;
}

.preference-card h6 {
    color: #495057;
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
    font-weight: 600;
}

.preference-value {
    font-size: 1.25rem;
    font-weight: 600;
    color: #556ee6;
}

.range-separator {
    margin: 0 0.5rem;
    color: #6c757d;
}

.range-unit {
    font-size: 0.875rem;
    color: #6c757d;
    margin-left: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .preference-group-content {
        padding: 1rem;
    }

    .preference-card {
        padding: 1.25rem;
    }

    .preference-icon i {
        font-size: 1.75rem;
    }

    .preference-value {
        font-size: 1.1rem;
    }
}

/* Additional preference styles */
.preference-note {
    font-size: 0.8rem;
    color: #6c757d;
    margin-top: 0.5rem;
}

.preference-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.preference-tag {
    background: #556ee6;
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    font-size: 0.85rem;
}

.location-details p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.location-details strong {
    color: #495057;
    margin-right: 0.5rem;
}

.map-card {
    padding: 0;
    overflow: hidden;
}

.map-card iframe {
    border: none;
    margin-bottom: -8px;
}

/* Update clickable styles */
.clickable.text-primary {
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;
}

.clickable.text-primary:hover {
    color: #485ec4 !important;
    text-decoration: underline;
}

.user-card.clickable {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.user-card.clickable:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

/* Keep buttons clickable */
.user-card .btn-link {
    position: relative;
    z-index: 2;
}

.user-card .info-item {
    background: #f8f9fa;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-card .user-stats .clickable:hover {
    background-color: #f8f9fa;
    cursor: pointer;
}

.user-card .user-info {
    font-size: 0.85rem;
}

.user-card .info-item i {
    font-size: 0.9rem;
}

.clickable-card {
    cursor: pointer;
}

.clickable-card input[type="checkbox"] {
    cursor: pointer;
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/users.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,8EAA8E;AAC9E;IACI,kBAAkB;AACtB;;AAEA;;IAEI,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,eAAe;IACf,uDAAuD;IACvD,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA,0BAA0B;AAC1B;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB,EAAE,8BAA8B;IACzD;;IAEA;QACI,aAAa,EAAE,8BAA8B;IACjD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA,gDAAgD;IAChD;QACI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,iCAAiC;QACjC,4CAA4C;QAC5C,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,aAAa,EAAE,6BAA6B;IAChD;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA,mCAAmC;IACnC;QACI,mBAAmB;IACvB;;IAEA,gCAAgC;IAChC;QACI,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,wCAAwC;IACxC;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,oCAAoC;IACpC;QACI,8BAA8B;QAC9B,eAAe;QACf,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,aAAa,EAAE,qBAAqB;IACxC;;IAEA;QACI,oBAAoB,EAAE,uBAAuB;QAC7C,iBAAiB;IACrB;;IAEA,8BAA8B;IAC9B;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA,4BAA4B;IAC5B;QACI,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA,yBAAyB;IACzB;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,iBAAiB;IACrB;;IAEA,sBAAsB;IACtB;QACI,gBAAgB;QAChB,2BAA2B;QAC3B,eAAe;IACnB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,+BAA+B;AAC/B;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;AACd","sourcesContent":["/* Core card styles */\n.user-card {\n    transition: all 0.3s ease;\n    height: 100%;\n}\n\n.user-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n.user-image-container {\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n}\n\n.image-wrapper {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    border-radius: 50%;\n    overflow: hidden;\n    background-color: #f8f9fa;\n}\n\n.user-avatar {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center top;\n}\n\n.user-card .badge {\n    font-size: 0.7rem;\n    padding: 0.3em 0.6em;\n}\n\n.user-card .text-muted {\n    font-size: 12px;\n}\n\n.user-card .card-body {\n    padding: 15px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.user-card h5.fs-16 {\n    font-size: 14px !important;\n    margin-bottom: 2px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-card .text-muted.mb-0 {\n    font-size: 12px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-card .hstack {\n    margin-top: 8px;\n}\n\n.user-card .pt-3 {\n    margin-top: auto;\n    font-size: 12px;\n}\n\n.user-card .fs-12 {\n    color: #74788d;\n    margin-bottom: 4px !important;\n}\n\n.user-card .fs-14 {\n    font-size: 13px !important;\n    min-height: 40px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-card .row .col-6 {\n    margin-bottom: 12px;\n}\n\n.user-card .d-flex.align-items-start {\n    margin-bottom: 12px;\n}\n\n.pagination-info {\n    color: #74788d;\n    font-size: 13px;\n}\n\n.clickable {\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.clickable:hover {\n    color: #556ee6;\n}\n\n.user-stats .btn-link {\n    color: #556ee6;\n    font-size: 14px;\n}\n\n.user-stats .btn-link:hover {\n    color: #485ec4;\n}\n\n.profile-details h4 {\n    margin-bottom: 0.5rem;\n}\n\n.profile-details .basic-info,\n.profile-details .search-preferences,\n.profile-details .attributes {\n    background-color: #f8f9fa;\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.profile-details h5 {\n    color: #495057;\n    font-size: 1.1rem;\n    margin-bottom: 1rem;\n}\n\n.profile-details h6 {\n    color: #6c757d;\n    font-size: 1rem;\n}\n\n.profile-details p {\n    margin-bottom: 0.5rem;\n}\n\n.profile-details strong {\n    color: #495057;\n}\n\n.attribute-group {\n    border-bottom: 1px solid #dee2e6;\n    padding-bottom: 1rem;\n}\n\n.attribute-group:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.profile-carousel {\n    background: #f8f9fa;\n    border-radius: 8px;\n    overflow: hidden;\n    height: 325px;\n    margin-bottom: 1rem;\n    position: relative;\n}\n\n.profile-carousel .carousel-inner,\n.profile-carousel .carousel-item {\n    height: 100%;\n    width: 100%;\n    background: #f8f9fa;\n}\n\n/* Update image styles to maintain aspect ratio */\n.profile-carousel img {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/* Update video styles to match */\n.profile-carousel video {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #000;\n}\n\n.profile-carousel .ratio {\n    width: 100%;\n    height: 100%;\n}\n\n/* Keep the carousel item relative for absolute positioning of images/videos */\n.profile-carousel .carousel-item {\n    position: relative;\n}\n\n.profile-carousel .carousel-control-prev,\n.profile-carousel .carousel-control-next {\n    background: rgba(0,0,0,0.2);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0 10px;\n    z-index: 3;\n}\n\n.profile-carousel .carousel-indicators {\n    margin-bottom: 0.5rem;\n    z-index: 3;\n}\n\n.attribute-item {\n    background-color: #f8f9fa;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    height: 100%;\n}\n\n.attribute-item h6 {\n    color: #495057;\n    margin-bottom: 0.5rem;\n    font-size: 0.9rem;\n}\n\n.attribute-item p {\n    color: #6c757d;\n    font-size: 0.875rem;\n}\n\n.nav-tabs .nav-link {\n    color: #495057;\n    font-weight: 500;\n    padding: 0.75rem 1rem;\n}\n\n.nav-tabs .nav-link.active {\n    color: #556ee6;\n    border-bottom: 2px solid #556ee6;\n}\n\n.badge {\n    padding: 0.5em 0.75em;\n    font-weight: 500;\n}\n\n.preference-group {\n    background-color: #f8f9fa;\n    padding: 1.25rem;\n    border-radius: 0.5rem;\n}\n\n.preference-group h6 {\n    color: #495057;\n    font-size: 0.95rem;\n    font-weight: 600;\n}\n\n.preference-group p {\n    margin-bottom: 0.75rem;\n    font-size: 0.875rem;\n}\n\n.preference-group p:last-child {\n    margin-bottom: 0;\n}\n\n/* Profile Tab Styling */\n.user-header {\n    text-align: center;\n    padding: 1.5rem;\n    background: linear-gradient(to right, #556ee6, #34c38f);\n    border-radius: 1rem;\n    color: white;\n}\n\n.user-header h3 {\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n}\n\n.user-meta {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.username {\n    font-size: 1.1rem;\n    opacity: 0.9;\n}\n\n.profile-completion-bar {\n    max-width: 300px;\n    margin: 0 auto;\n}\n\n.progress-bar {\n    background: #34c38f;\n}\n\n/* Stats Cards */\n.stat-card {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 1rem;\n    text-align: center;\n    box-shadow: 0 0 15px rgba(0,0,0,0.05);\n    transition: transform 0.3s ease;\n}\n\n.stat-card:hover {\n    transform: translateY(-5px);\n}\n\n.stat-card i {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n}\n\n.stat-card h4 {\n    margin-bottom: 0.25rem;\n    font-weight: 600;\n}\n\n.stat-card span {\n    color: #74788d;\n    font-size: 0.9rem;\n}\n\n/* Info Cards */\n.info-card {\n    background: white;\n    border-radius: 1rem;\n    overflow: hidden;\n    box-shadow: 0 0 15px rgba(0,0,0,0.05);\n}\n\n.info-header {\n    background: #f8f9fa;\n    padding: 1rem 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.info-header i {\n    font-size: 1.5rem;\n    color: #556ee6;\n}\n\n.info-header h5 {\n    margin: 0;\n    font-weight: 600;\n}\n\n.info-content {\n    padding: 1.5rem;\n}\n\n.info-item {\n    margin-bottom: 1.25rem;\n}\n\n.info-item:last-child {\n    margin-bottom: 0;\n}\n\n.info-item label {\n    display: block;\n    color: #74788d;\n    font-size: 0.875rem;\n    margin-bottom: 0.25rem;\n}\n\n.info-item p {\n    margin: 0;\n    font-weight: 500;\n}\n\n.about-text {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #495057;\n}\n\n.status-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.status-item i {\n    font-size: 1.25rem;\n}\n\n.status-item span {\n    font-size: 0.95rem;\n    color: #495057;\n}\n\n.profile-carousel .carousel-item.active {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.video-wrapper {\n    position: relative;\n    cursor: pointer;\n    height: 100%;\n    width: 100%;\n}\n\n.video-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,0.2);\n    opacity: 0;\n    transition: opacity 0.2s;\n    z-index: 2;\n}\n\n.video-wrapper:hover .video-overlay {\n    opacity: 1;\n}\n\n.video-overlay i {\n    font-size: 48px;\n    color: white;\n    pointer-events: none;\n}\n\n/* Add these styles for tabs */\n.nav-link {\n    cursor: pointer;\n}\n\n.nav-tabs .nav-link {\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.nav-tabs .nav-link:hover {\n    background-color: #f8f9fa;\n    border-color: transparent;\n}\n\n.nav-tabs .nav-link.active {\n    border-bottom: 2px solid #556ee6;\n    background-color: transparent;\n}\n\n/* Add responsive styles */\n@media (max-width: 1200px) {\n    .profile-carousel {\n        height: 400px;\n    }\n}\n\n@media (max-width: 992px) {\n    .profile-carousel {\n        height: 350px;\n    }\n}\n\n@media (max-width: 768px) {\n    .profile-carousel {\n        height: 300px;\n    }\n\n    .info-card {\n        margin-bottom: 1rem;\n    }\n\n    .info-header {\n        padding: 0.75rem 1rem; /* Smaller padding on mobile */\n    }\n\n    .info-content {\n        padding: 1rem; /* Smaller padding on mobile */\n    }\n\n    .status-item {\n        margin-bottom: 0.75rem;\n    }\n\n    /* Make tabs scrollable horizontally on mobile */\n    .nav-tabs {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        overflow-y: hidden;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        white-space: nowrap;\n        margin-bottom: 1rem;\n    }\n\n    .nav-tabs::-webkit-scrollbar {\n        display: none; /* Hide scrollbar on mobile */\n    }\n\n    .nav-tabs .nav-link {\n        padding: 0.5rem 1rem;\n        font-size: 0.9rem;\n    }\n\n    /* Adjust table display on mobile */\n    .table-responsive {\n        margin-bottom: 1rem;\n    }\n\n    /* Adjust pagination on mobile */\n    .pagination {\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n\n    .pagination-item {\n        margin: 0.25rem;\n    }\n\n    /* Improve attribute display on mobile */\n    .attribute-item {\n        margin-bottom: 1rem;\n    }\n\n    .attribute-item h6 {\n        font-size: 0.9rem;\n    }\n\n    .attribute-item p {\n        font-size: 0.85rem;\n    }\n}\n\n@media (max-width: 576px) {\n    .profile-carousel {\n        height: 250px;\n    }\n\n    .info-header h5 {\n        font-size: 1rem;\n    }\n\n    .status-item {\n        font-size: 0.85rem;\n    }\n\n    .about-text {\n        font-size: 0.9rem;\n    }\n\n    /* Update button styles for mobile */\n    .action-buttons {\n        flex-direction: row !important;\n        flex-wrap: wrap;\n        gap: 0.5rem !important;\n        justify-content: flex-end;\n    }\n\n    .action-buttons .btn {\n        width: auto !important;\n        padding: 0.5rem !important;\n    }\n\n    .action-buttons .btn span {\n        display: none; /* Hide button text */\n    }\n\n    .action-buttons .btn i {\n        margin: 0 !important; /* Remove icon margin */\n        font-size: 1.1rem;\n    }\n\n    /* Make filter button square */\n    .action-buttons .dropdown button {\n        width: auto !important;\n        padding: 0.5rem !important;\n    }\n\n    .action-buttons .dropdown button span {\n        display: none;\n    }\n\n    /* Adjust search bar width */\n    .search-box {\n        width: 150px !important;\n        margin-left: auto;\n    }\n\n    /* Adjust header layout */\n    .card-header .row {\n        display: flex;\n        align-items: center;\n    }\n\n    .card-header .col-sm-4 {\n        margin-bottom: 0 !important;\n        padding: 0 0.5rem;\n    }\n\n    /* Title adjustments */\n    .card-title {\n        text-align: left;\n        margin-bottom: 0 !important;\n        font-size: 1rem;\n    }\n}\n\n/* Attributes Tab Styling */\n.attributes-wrapper {\n    padding: 1rem;\n}\n\n.attribute-section {\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 0 15px rgba(0,0,0,0.05);\n}\n\n.attribute-group-header {\n    background: #f8f9fa;\n    padding: 1rem 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.attribute-group-header i {\n    font-size: 1.25rem;\n    color: #556ee6;\n}\n\n.attribute-group-header h5 {\n    margin: 0;\n    font-weight: 600;\n    color: #495057;\n}\n\n.attribute-group-content {\n    padding: 1.5rem;\n}\n\n.attribute-card {\n    background: #f8f9fa;\n    padding: 1rem;\n    border-radius: 8px;\n    height: 100%;\n    transition: all 0.3s ease;\n    border: 1px solid #e9ecef;\n}\n\n.attribute-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0,0,0,0.08);\n    border-color: #556ee6;\n}\n\n.attribute-title {\n    color: #495057;\n    font-size: 0.9rem;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n}\n\n.attribute-value {\n    color: #6c757d;\n    font-size: 0.875rem;\n    margin: 0;\n    line-height: 1.5;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .attribute-group-content {\n        padding: 1rem;\n    }\n\n    .attribute-card {\n        padding: 0.875rem;\n    }\n\n    .attribute-title {\n        font-size: 0.85rem;\n    }\n\n    .attribute-value {\n        font-size: 0.8rem;\n    }\n}\n\n/* Search Preferences Styling */\n.preferences-wrapper {\n    padding: 1rem;\n}\n\n.preference-section {\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 0 15px rgba(0,0,0,0.05);\n}\n\n.preference-group-header {\n    background: #f8f9fa;\n    padding: 1rem 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.preference-group-header i {\n    font-size: 1.25rem;\n    color: #556ee6;\n}\n\n.preference-group-header h5 {\n    margin: 0;\n    font-weight: 600;\n    color: #495057;\n}\n\n.preference-group-content {\n    padding: 1.5rem;\n}\n\n.preference-card {\n    background: #f8f9fa;\n    padding: 1.5rem;\n    border-radius: 8px;\n    height: 100%;\n    transition: all 0.3s ease;\n    border: 1px solid #e9ecef;\n    text-align: center;\n}\n\n.preference-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0,0,0,0.08);\n    border-color: #556ee6;\n}\n\n.preference-icon {\n    margin-bottom: 1rem;\n}\n\n.preference-icon i {\n    font-size: 2rem;\n    color: #556ee6;\n}\n\n.preference-card h6 {\n    color: #495057;\n    font-size: 0.9rem;\n    margin-bottom: 0.75rem;\n    font-weight: 600;\n}\n\n.preference-value {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #556ee6;\n}\n\n.range-separator {\n    margin: 0 0.5rem;\n    color: #6c757d;\n}\n\n.range-unit {\n    font-size: 0.875rem;\n    color: #6c757d;\n    margin-left: 0.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .preference-group-content {\n        padding: 1rem;\n    }\n\n    .preference-card {\n        padding: 1.25rem;\n    }\n\n    .preference-icon i {\n        font-size: 1.75rem;\n    }\n\n    .preference-value {\n        font-size: 1.1rem;\n    }\n}\n\n/* Additional preference styles */\n.preference-note {\n    font-size: 0.8rem;\n    color: #6c757d;\n    margin-top: 0.5rem;\n}\n\n.preference-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.preference-tag {\n    background: #556ee6;\n    color: white;\n    padding: 0.25rem 0.75rem;\n    border-radius: 1rem;\n    font-size: 0.85rem;\n}\n\n.location-details p {\n    margin-bottom: 0.5rem;\n    font-size: 0.9rem;\n}\n\n.location-details strong {\n    color: #495057;\n    margin-right: 0.5rem;\n}\n\n.map-card {\n    padding: 0;\n    overflow: hidden;\n}\n\n.map-card iframe {\n    border: none;\n    margin-bottom: -8px;\n}\n\n/* Update clickable styles */\n.clickable.text-primary {\n    text-decoration: none;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.clickable.text-primary:hover {\n    color: #485ec4 !important;\n    text-decoration: underline;\n}\n\n.user-card.clickable {\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.user-card.clickable:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n/* Keep buttons clickable */\n.user-card .btn-link {\n    position: relative;\n    z-index: 2;\n}\n\n.user-card .info-item {\n    background: #f8f9fa;\n    padding: 0.5rem;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-card .user-stats .clickable:hover {\n    background-color: #f8f9fa;\n    cursor: pointer;\n}\n\n.user-card .user-info {\n    font-size: 0.85rem;\n}\n\n.user-card .info-item i {\n    font-size: 0.9rem;\n}\n\n.clickable-card {\n    cursor: pointer;\n}\n\n.clickable-card input[type=\"checkbox\"] {\n    cursor: pointer;\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
